import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TableCellComponent } from '../../table/table.model';
import { TooltipDirective, TooltipType } from '@cumlaude/shared-components-overlays';
import { isNil } from 'lodash-es';
import { IconComponent, IconName } from '@cumlaude/shared-components-icons';

type LabelWithTooltip = { text: string; tooltip?: string; icon?: IconName };

export type LabelCellData = string | null | LabelWithTooltip;

@Component({
	selector: 'app-label-cell',
	templateUrl: './label-cell.component.html',
	styleUrls: ['./label-cell.component.scss'],
	imports: [TooltipDirective, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelCellComponent implements TableCellComponent<LabelCellData> {
	data!: LabelCellData;
	className?: string;
	tooltip?: TooltipType;

	getText(data: LabelCellData): string {
		if (isNil(data)) return '';
		return typeof data === 'string' ? data : data.text;
	}

	getLabelWithTooltip(data: LabelCellData): LabelWithTooltip | undefined {
		if (isNil(data)) return { text: '' };
		return typeof data === 'string' ? undefined : data;
	}

	getExportValue(data: LabelCellData) {
		return this.getText(data);
	}
}
